module.exports = __webpack_public_path__ + "static/quiz4_question3-dfc8e039ae3536036813f02298e1aace.jpg";